module.exports = __webpack_public_path__ + "img/SiteLink.1a2c37f3.svg";